<app-header></app-header>
<app-loader-indicator [displayLoadingText]="'Loading... Please wait'"></app-loader-indicator>
<router-outlet />
<app-footer></app-footer>
